// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueMqtt from 'vue-mqtt'
import Pagination from '@/components/Pagination'
//引入样式
import '@jyeontu/jvuewheel/lib/jvuewhell.css'
//全量引入组件库
import jvuewheel from '@jyeontu/jvuewheel'

Vue.config.productionTip = false

Vue.component(Pagination.name, Pagination)
Vue.use(ElementUI)
Vue.use(jvuewheel);
const mqBaseUrl = process.env.NODE_ENV==="development" ? 'ws://192.168.80.59:8083/mqtt':"ws://47.98.55.5:28083/mqtt"
Vue.prototype.$baseUrl = process.env.NODE_ENV==="development" ? 'http://192.168.80.51':"https://app.hkaspire.cn"
// Vue.use(VueMqtt, mqBaseUrl)
// Vue.use(VueMqtt, 'wss://wxx.screen.hkaspire.cn/mqtt')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js